import { AlertTriangle, CheckCircle2, Info, XCircle } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "./cn";

const TONES = {
  info: { box: "border-info/40 bg-info-light", icon: Info, color: "text-info" },
  warn: { box: "border-warn/40 bg-warn-light", icon: AlertTriangle, color: "text-warn" },
  bad: { box: "border-bad/40 bg-bad-light", icon: XCircle, color: "text-bad" },
  ok: { box: "border-ok/40 bg-ok-light", icon: CheckCircle2, color: "text-ok" },
} as const;

export function Notice({ tone = "info", title, children, className, action }: { tone?: keyof typeof TONES; title?: ReactNode; children?: ReactNode; className?: string; action?: ReactNode }) {
  const t = TONES[tone];
  const Icon = t.icon;
  return (
    <div role={tone === "bad" ? "alert" : "status"} className={cn("flex flex-wrap items-start gap-3 rounded-md border px-4 py-3", t.box, className)}>
      <Icon className={cn("mt-0.5 size-5 shrink-0", t.color)} />
      <div className="min-w-0 flex-1 basis-60 text-sm">
        {title && <p className={cn("font-bold", t.color)}>{title}</p>}
        {children && <div className="text-ink-2">{children}</div>}
      </div>
      {action && <div className="w-full shrink-0 sm:w-auto [&>*]:w-full sm:[&>*]:w-auto">{action}</div>}
    </div>
  );
}
